module.exports = __webpack_public_path__ + "build/img/der_s.44bea99c.png";